/* oxlint-disable react/exhaustive-deps */
import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackPopupShow, trackPopupClose } from './tracking';
import { LastHopePopup } from '../../components/LastHopePopup';
import { LAST_HOPE_SHOWED_DELAY, LIMIT_IN_A_DAY } from '../../constants/lastHopePopup';
import { getBuilders, getFromDevelopersPropsCount, getNewbuildingId } from '../../selectors/newbuilding';
import { getIsCompareFlightModalOpen } from '../../selectors/compareFlightTooltip';
import {
  incrementCountPopupShowed,
  isPopupHistoryExpired,
  isShowingsLimitReached,
  isUserOpenedPhoneInNewobject,
  resetPopupShowingsHistory,
} from '../../utils/lastHopePopup';
import { LastHopePopupCall } from '../Call/LastHopePopupCall';

export function LastHopePopupContainer() {
  const [isOpened, setOpenedState] = React.useState(false);

  const builders = useSelector(getBuilders);
  const newbuildingId = useSelector(getNewbuildingId);
  const fromDevelopersPropsCount = useSelector(getFromDevelopersPropsCount);
  const builderWithPhones = builders.find(builder => builder.phone && builder.phone.number);
  const isCompareFlightModalOpen = useSelector(getIsCompareFlightModalOpen);
  const isBlockedRef = React.useRef(isCompareFlightModalOpen);
  isBlockedRef.current = isCompareFlightModalOpen;

  React.useEffect(() => {
    if (isPopupHistoryExpired(24)) {
      resetPopupShowingsHistory();
    }

    const id = setTimeout(() => {
      const opened =
        fromDevelopersPropsCount !== 0 &&
        !!builderWithPhones &&
        !isUserOpenedPhoneInNewobject(newbuildingId) &&
        !isShowingsLimitReached(LIMIT_IN_A_DAY, 24);

      if (opened && !isBlockedRef.current) {
        setOpenedState(opened);
        trackPopupShow();
        incrementCountPopupShowed();
      }
    }, LAST_HOPE_SHOWED_DELAY);

    /* istanbul ignore next */
    return () => clearTimeout(id);
  }, []);

  const onClose = React.useCallback(() => {
    setOpenedState(false);
    trackPopupClose();
  }, []);

  return (
    <LastHopePopup
      builderName={builderWithPhones ? builderWithPhones.name : null}
      callButton={<LastHopePopupCall />}
      isOpened={isOpened}
      onClose={onClose}
    />
  );
}
